import { isEqual } from 'lodash';
import { HYDRATE } from 'next-redux-wrapper';
import { GlobalActions } from '@state/store';
import { BaseAction } from '@model/redux';
import { NavDestinations, PageData } from '@model/content';

/* ***************** *
 *       TYPES       *
 * ***************** */
export type CmsPayload = Array<any> | any;

export interface CMSState {
  navDestinations: NavDestinations | null;
  navOffers: Array<PageData>;
  navInfo: Array<PageData>;
}

export interface CMSAction extends BaseAction {
  type: CMSActionTypes | GlobalActions;
  payload: any;
}

/* ***************** *
 *   ACTION TYPES    *
 * ***************** */

export enum CMSActionTypes {
  SET_NAV_DESTINATIONS = '@CMS/SET_NAV_DESTINATIONS',
  SET_NAV_OFFERS = '@CMS/SET_NAV_OFFERS',
  SET_NAV_INFO = '@CMS/SET_NAV_INFO'
}

/* ***************** *
 *     ACTIONS       *
 * ***************** */

export interface SetNavDestinationsType extends BaseAction {
  type: CMSActionTypes.SET_NAV_DESTINATIONS;
  payload: NavDestinations;
}

export function setNavDestinations(payload: NavDestinations): SetNavDestinationsType {
  return {
    type: CMSActionTypes.SET_NAV_DESTINATIONS,
    payload
  };
}

export interface SetNavOffersType extends BaseAction {
  type: CMSActionTypes.SET_NAV_OFFERS;
  payload: Array<PageData>;
}

export function setNavOffers(payload: Array<PageData>): SetNavOffersType {
  return {
    type: CMSActionTypes.SET_NAV_OFFERS,
    payload
  };
}

export interface SetNavInfoType extends BaseAction {
  type: CMSActionTypes.SET_NAV_INFO;
  payload: Array<PageData>;
}

export function setNavInfo(payload: Array<PageData>): SetNavInfoType {
  return {
    type: CMSActionTypes.SET_NAV_INFO,
    payload
  };
}

/* ***************** *
 *     REDUCER       *
 * ***************** */

export const CMS_INITIAL_STATE: CMSState = {
  navDestinations: null,
  navOffers: [],
  navInfo: []
};

export const cmsReducer = (state: CMSState = CMS_INITIAL_STATE, action: CMSAction) => {
  switch (action.type) {
    case HYDRATE:
      if (isEqual(state, CMS_INITIAL_STATE)) {
        return action.payload?.cms || state;
      }
      return state;
    case CMSActionTypes.SET_NAV_DESTINATIONS:
      return {
        ...state,
        navDestinations: action.payload
      };
    case CMSActionTypes.SET_NAV_OFFERS:
      return {
        ...state,
        navOffers: action.payload
      };
    case CMSActionTypes.SET_NAV_INFO:
      return {
        ...state,
        navInfo: action.payload
      };
    default:
      return state;
  }
};
